import { DashboardShell } from "@/components/dashboard-shell"
import { SettingsView } from "@/components/settings/settings-view"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: SettingsPage,
  head: () => ({ meta: [{ title: "Settings" }] }),
});

function SettingsPage() {
  return (
    <DashboardShell>
      <SettingsView />
    </DashboardShell>
  )
}
